const e = {
  name: "Megaphone",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34,0h6v36h-6v-3.4l-16-8V40h-6.7L4,23.2V22H0V12h4v-2h12.8L34,2.4V0z M4,14H2v6h2V14z M16,22V12H6v10H16z
			 M18,22.4l16,8V4.5l-16,7.1V22.4z M36,34h2V2h-2V34z M6.5,24l6.1,14H16V24H6.5z"/>
		<path class="st0" d="M20,29v6h2v-6H20z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Megaphone
};
